<template>
<el-container class="hotellist-main" id="main">
  <publicHeader @hotelDetailCurrency="hotelDetailCurrency" @hotelLanguage="hotelLanguage"></publicHeader>
  <el-main>
      <div class="main" :style="{minHeight: `${mainMinHeight}px`}">
        <publicSearchCond :key="timer" ref="childCond" :regionSelData="regionSelDetail" :hotelFirstData="hotelFirstData" :hotelRoomSearchFixed="hotelRoomSearchFixed" :hotelRoomSearchFixedPlaceholder="hotelRoomSearchFixedPlaceholder" @getSearchInfo="getSearchInfo"></publicSearchCond>
        <!--搜索结果 开始-->
        <div class="list-content">
            <div class="directory is-hidden">
              <router-link :to="{name:'Home', params: {'querys': common.linkEncode({'source': source}, 'obj')}}">{{$t('home')}}</router-link>
              <span class="slash" v-if="country!==''">/</span>
              {{country}}
              <span class="slash" v-if="city!==''">/</span>
              <span style="color:#5392F9" class="curPointer" @click="selectHotelList()">{{city}}</span>
            </div>
            <!--细致搜索 开始-->
            <div class="list-search-all">
                <!--左侧筛选 开始-->
                <div class="list-left">
                  <!-- <div class="keyword-search el-input el-input--large el-input--suffix">
                    <input type="text" autocomplete="off" :placeholder="$t('searchByProperty')" class="el-input__inner" onkeydown="handleKeyDown(event)">
                  </div> -->
                  <el-input :placeholder="$t('searchByProperty')" v-model="keyword" style="width:95%;height:40px;" @keyup.enter.native="handleKeyUp">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                  <div class="starsearch">
                    <div>{{$t('propertyClass')}}</div>
                    <div class="starlevel">
                      <el-checkbox-group v-model="checkedLevel" @change="handlecheckedLevelChange">
                          <div>
                              <el-checkbox :id="key" v-for="(level, key) in levels" :label="key" :key="level">
                                  <span v-html="propertyClassLanguage(key)"></span>
                              </el-checkbox>
                          </div>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <div class="starsearch">
                    <div>{{$t('pricePerNight')}}</div>
                    <div class="starlevel">
                      <el-checkbox-group v-model="checkedBudget" @change="handleCheckedBudgetChange">
                          <div><el-checkbox v-for="(budget, key) in budgets" :label="key" :key="budget" :disabled="budgetNo[key]">{{budget}}</el-checkbox></div>
                      </el-checkbox-group>
                    </div>
                  </div>
                </div>
                <!--左侧筛选 结束-->
                <!--手机版本搜索-->
                <div class="list-top">
                  <div style="display:inline-block; width: 100%; float: left;">
                    <el-button class="top-search" :class="{'blue-search': showFilter === true || showFilter === 'true'}" size="mini" round  @click="hotelSearchStar = true"><i class="el-icon-s-operation"></i> {{$t('filter')}}</el-button>
                    <el-button @click="viewSort = true" class="top-search" :class="{'blue-search': showSort === true || showSort === 'true'}" size="mini" round>
                      <i class="el-icon-caret-bottom" style="float: right;"></i>{{$t('sortby')}}<a v-if="showSort === true || showSort === 'true'"><a v-if="language === 'zh'">{{sortTextzh[hotelType]}}</a><a v-else>{{sortTexten[hotelType]}}</a></a>
                    </el-button>
                    <el-drawer :show-close="viewSortShowClose" :visible.sync="viewSort" direction="btt">
                      <div slot="title" style="text-align: center; position: relative;">
                        {{$t('sortby')}}
                        <i class="el-dialog__close el-icon el-icon-close" style="position: absolute;right: 0;" @click="viewSort = false"></i>
                      </div>
                      <div class="sort-info">
                        <div @click="clickistop('hot', $t('bestMatch'))" :class="{'blue-text':istop0}">{{$t('bestMatch')}}</div>
                        <div @click="clickistop('low', $t('lowPriceFirst'))" :class="{'blue-text':istop1}">{{$t('lowPriceFirst')}}</div>
                        <div @click="clickistop('high', $t('highPropertyClass'))" :class="{'blue-text':istop2}">{{$t('highPropertyClass')}}</div>
                      </div>
                    </el-drawer>
                    <!-- <el-button class="cond-search" size="mini" round v-show="showLevel"><i class="el-icon-close" style="float: right;margin-left: 5px;" @click="closeLevel"></i>{{$t('propertyClass')}}</el-button>
                    <el-button class="cond-search" size="mini" round v-show="showBudget"><i class="el-icon-close" style="float: right;margin-left: 5px;" @click="closeBudget"></i>{{$t('pricePerNight')}}</el-button> -->
                  </div>
                </div>
                <!--手机版本搜索 结束-->
                <!--右侧展示 开始-->
                <div class="list-right" id="right">
                  <div class="tagAll" style="min-height: 40px;line-height: 40px;">
                    <div id="select-cond" style="display:inline-block;margin-bottom: 1px;" v-for="cond in selectConds" :key="cond">
                      <div class="el-tag el-tag--light">
                        <span v-if="language === 'zh'">
                          <b v-if="oldBudgetsRev[cond] !== '' && oldBudgetsRev[cond] !== undefined">{{budgets[oldBudgetsRev[cond]]}}</b>
                          <b v-else>{{cond}}</b>
                        </span>
                        <span v-else>
                          <b v-if="levelText[cond] !== '' && levelText[cond] !== undefined">{{levelTextEn[levelText[cond]]}}</b>
                          <b v-else-if="oldBudgetsRev[cond] !== '' && oldBudgetsRev[cond] !== undefined">
                            {{budgets[oldBudgetsRev[cond]]}}
                          </b>
                          <b v-else>{{cond}}</b>
                        </span>
                        <img @click="tagClose(cond)" class="imgclose" src="https://res.roompai.com/static/img/hotelsearch/FCD205.png">
                      </div>
                    </div>
                    <div class="closeAll" @click="closeAll">{{$t('deleteFilter')}} <span class="condNum">{{condNum}}</span> {{$t('filters')}}</div>
                  </div>
                  <div class="content">
                    <div class="top is-hidden">
                      <div id="tab-0" class="istop-0" @click="clickistop('hot', $t('bestMatch'))" :class="{'istop-select-0':istop0}">{{$t('bestMatch')}}</div>
                      <div id="tab-1" class="istop-1" @click="clickistop('low', $t('lowPriceFirst'))" :class="{'istop-select-1':istop1}">{{$t('lowPriceFirst')}}</div>
                      <div id="tab-2" class="istop-2" @click="clickistop('high', $t('highPropertyClass'))" :class="{'istop-select-2':istop2}">{{$t('highPropertyClass')}}</div>
                    </div>
                    <div>
                      <div v-show="cotentEmptyShow" class="content-empty">
                        <div><img src="https://res.roompai.com/static/img/hotelsearch/hotellist-no.png" class="content-empty-img"></div>
                        <div class="content-empty-text">
                          <div v-html="$t('pleaseModifyYourSearchAndTryAgain')"></div>
                        </div>
                      </div>
                      <div>
                        <el-skeleton :count="5" :loading="cotentShow">
                          <template slot="template">
                            <div class="hotellist">
                              <div class="hotelImgs">
                                <div>
                                  <div class="roompic">
                                    <el-skeleton-item variant="image" class="hotelImg" />
                                  </div>
                                </div>
                              </div>
                              <div class="hotelmess">
                                <div class="hotelMessage">
                                  <el-skeleton-item variant="text" />
                                  <div class="hoteltags">
                                    <el-skeleton-item variant="text" style="width: 30%;" />
                                  </div>
                                  <div class="hotellocation">
                                    <el-skeleton-item variant="text" />
                                  </div>
                                </div>
                                <div class="hotelselect">
                                  <div class="remain-empty"></div>
                                  <div class="hotelmoney"><el-skeleton-item variant="text" style="width: 50px;" class="currency-text" /></div>
                                  <!-- <div class="doselect" style="background-color: #f2f2f2;">
                                    {{$t('selectRoom')}}
                                    <img style="width:14px;height:14px;margin-bottom:-2px;" src="https://res.roompai.com/static/img/hotelsearch/FFFFFF.png">
                                  </div> -->
                                </div>
                              </div>
                            </div>
                          </template>
                          <!--内容显示-->
                          <template>
                            <el-card :body-style="{ padding: '0px' }" v-for="(value, id) in listInfo" :key="value.hotelid">
                              <div class="match-hotel" v-show="id === 0 && (value.ismatch === true || value.ismatch === 'true')">
                                {{ $t('matchHotelMsg') }}
                              </div>
                              <div class="hotellist" :class="value.tag">
                                <div class="hotelImgs">
                                  <div @click="gotoDetail(value.hotelid, value.name, start_date, end_date, roomNum, adultNum, childNum)">
                                    <div v-if="value.pic !== ''" class="roompic"><img class="hotelImg" :src="value.pic"></div>
                                    <div v-else class="noroomimg">
                                      <img class="hotelImg" :src="value.dpic">
                                      <div class="no-room-img text-font-hidden">{{$t('nopic')}}</div>
                                    </div>
                                  </div>
                                  <!-- <div :class="'hotel-like-'+value.islike" @click="collect('major', id, value.hotelid, value.islike)"></div> -->
                                  <div>
                                    <svg @click="collect('other', id, value.hotelid, value.islike)" :class="'hotel-like-'+value.islike" id="heart" viewBox="-2 0 105 92" data-love-level="0">
                                      <path d="M85.24 2.67C72.29-3.08 55.75 2.67 50 14.9 44.25 2 27-3.8 14.76 2.67 1.1 9.14-5.37 25 5.42 44.38 13.33 58 27 68.11 50 86.81 73.73 68.11 87.39 58 94.58 44.38c10.79-18.7 4.32-35.24-9.34-41.71z"></path>
                                    </svg>
                                  </div>
                                </div>
                                <div class="hotelmess" :class="'sold'+value.price+language" @click="gotoDetail(value.hotelid, value.name, start_date, end_date, roomNum, adultNum, childNum)">
                                  <div class="hotelMessage">
                                    <div class="hotelname" v-if="language === 'zh'">{{value.hotelname_zh}}<span v-if="value.hotelname !== ''">({{value.hotelname}})</span></div>
                                    <div class="hotelname" v-else>{{value.hotelname}}</div>
                                    <div class="hoteltags">
                                      <span style="margin-right: 3px;" v-for="n in parseInt(value.star)" :key="n">
                                        <img style="width:15px;height:15px;" src="/static/img/star.png">
                                      </span>
                                      <span style="margin-left: -3px;" v-if="value.star_decimal === 1">
                                        <img style="width:15px;height:15px;" src="/static/img/star-decimal.png">
                                      </span>
                                    </div>
                                    <div class="hotellocation">
                                      <span v-if="language === 'zh'"><a v-if="value.hoteladdress_zh !== ''">{{value.hoteladdress_zh}}</a><a v-else>{{value.hoteladdress}}</a></span>
                                      <span v-else>{{value.hoteladdress}}</span>
                                    </div>
                                  </div>
                                  <div class="hotelselect" v-if="value.price!==0">
                                      <div  v-if="value.surplusnum > 0 && value.surplusnum === 1" class="remain">
                                        {{$t('onlyLast')}} {{value.surplusnum}} {{$t('onOurSite')}}
                                      </div>
                                      <div  v-else-if="value.surplusnum > 1" class="remain">
                                        {{$t('onlyLast')}} {{value.surplusnum}} {{$t('onOurSites')}}
                                      </div>
                                      <div v-else class="remain-empty"></div>
                                      <div class="hotelmoney"><span class="currency-text">{{listCurrency}}</span>{{value.price}}</div>
                                      <div class="doselect">
                                        {{$t('selectRoom')}}
                                        <img style="width:14px;height:14px;margin-bottom:-2px;" src="https://res.roompai.com/static/img/hotelsearch/FFFFFF.png">
                                      </div>
                                  </div>
                                  <div class="hotelprice-empty" v-else >
                                    <div v-if="ismobile === false">
                                      {{$t('soldLeft')}}
                                      <span style="color:#5392F9;" @click.stop="focusDate(value.hotelid, value)">{{$t('soldChangeDate')}}</span>
                                      {{$t('soldOr')}}
                                      <span style="color:#5392F9;" @click.stop="rollToFirst(value.hotelid)">{{$t('soldOtherHotel')}}</span>
                                      {{$t('soldRight')}}
                                    </div>
                                    <div v-else>
                                      {{$t('hoteListSold')}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </el-card>
                          </template>
                        </el-skeleton>
                        <!--分页 开始-->
                        <div class="hotelpages">
                          <div class="hotel-totaltext">{{city}}：<span v-if="language === 'zh'">共</span> <span class="hotelnum">{{listTotalAll}}</span> {{$t('properties')}}</div>
                          <div class="pageinfo">
                            <div class="block">
                              <el-pagination :page-size="pageSize"  @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="7" layout="prev, pager, next" :total="listTotal" :current-page="currentPage"></el-pagination>
                            </div>
                          </div>
                        </div>
                        <!--分页 结束-->
                      </div>
                    </div>
                  </div>
                </div>
                <!--右侧展示 结束-->
            </div>
            <!--细致搜索 结束-->
        </div>
        <!--搜索结果 结束-->
      </div>
  </el-main>
  <HotelSearchCond :hotelSearchStar="hotelSearchStar" :budgets="budgets" ref="child" @getSearchStar="getSearchStar" @closepop="closepopEven"></HotelSearchCond>
  <FrameQuotation :frameQuotationDialog="frameQuotationDialog"></FrameQuotation>
  <publicFooter :languageSet="language"></publicFooter>
</el-container>
</template>

<script>
import { texthotelList } from '@/request/hotel.js'
import { doCollect } from '@/request/collect.js'
import { getCityInfo } from '@/request/city.js'
import { hotelCurrency } from '@/request/currency.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicSearchCond from '@/components/public/publicSearchCond'
import HotelSearchCond from '@/components/hotelsearch/HotelSearchCond'
import FrameQuotation from '@/components/public/frameQuotation.vue'
const childSelected = {'0': 'selectedone'}
export default {
  name: 'TextHotelList',
  components: {
    publicFooter,
    publicHeader,
    publicSearchCond,
    HotelSearchCond,
    FrameQuotation
  },
  data () {
    return {
      hotelSearchStar: false,
      listInfo: [],
      noListInfo: [],
      cotentShow: true,
      cotentEmptyShow: false,
      input_region: '',
      input_date: '',
      input_person: '',
      activeIndex: 0,
      condNum: 0,
      checkedLevel: [],
      levels: this.common.levelOptions,
      checkedBudget: [],
      budgets: {},
      budgetRev: {},
      oldBudgetsRev: {},
      budgetSelectIds: [],
      budgetNo: {5: false, 6: false, 7: false, 8: false, 9: false},
      inputVisible: false,
      inputValue: '',
      selectConds: [],
      selectLevelConds: [],
      selectBudgetConds: [],
      levelText: this.common.levelOptionsRev,
      levelTextEn: this.common.levelOptionsEn,
      budgetText: ['< CNY 500', 'CNY 500 - 1000', 'CNY 1000 - 1500', 'CNY 1500 - 2500', '> CNY 2500'],
      showFilter: false,
      showSort: false,
      istop0: true,
      istop1: false,
      istop2: false,
      roomNum: 1,
      adultNum: 2,
      childNum: 0,
      personInfo: '2',
      roomInfo: '1',
      num: 1,
      showPersonInfo: false,
      roomLessDo: false,
      roomAddNoDo: false,
      adultLessDo: false,
      childLessDo: false,
      childAddNoDo: false,
      showChildInfo: false,
      childOld: this.common.childOld,
      childSelected: childSelected,
      selected: '',
      selecteds: [],
      hotelType: 'hot',
      currentPage: 1, // 当前默认显示第几页
      listTotal: 0, // 分页总条数
      listTotalAll: 0, // 总条数-完全匹配酒店+附近三家+重点酒店+其他酒店
      pageSize: 20, // 每页显示多少条数据，记住这里一定要是10的倍数，不然无效
      allPersonNum: 2,
      sortvalue: '',
      regionval: '',
      state: '',
      region_select: '',
      country: '',
      city: '',
      cityid: 0,
      countryid: 0,
      start_date: '',
      end_date: '',
      region_type: 3, // 目的地类型
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      listCurrency: 'CNY',
      keyword: '',
      frameQuotationDialog: false,
      search_json: {},
      keyword_json: {},
      searchTopping: '',
      hotelRoomSearchFixed: '',
      hotelRoomSearchFixedPlaceholder: '',
      timer: '',
      cityData: {},
      viewSort: false,
      viewSortShowClose: false,
      sortTextzh: {'hot': '：热门推荐', 'low': '：低价优先', 'high': '：高星优先'},
      sortTexten: {'hot': ': Best match', 'low': ': Low price first', 'high': ': High property class'},
      sortText: '',
      ismobile: false,
      regionSelDetail: {},
      hotelFirstData: {},
      source: 'roompai',
      mainMinHeight: document.documentElement.clientHeight - 60 - 241,
      mustTotal: 0
    }
  },
  mounted () {
    var platfromParam = {
      'sky_fclid': this.common.linkQuerys.fclid
    }
    sessionStorage.setItem('platfromParam', JSON.stringify(platfromParam))

    var language = this.common.linkQuerys.language
    if (language !== '' && language !== undefined && language !== null) {
      this.language = language
    }
    var currency = this.common.linkQuerys.currency
    if (currency !== '' && currency !== undefined && currency !== null) {
      this.currency = currency
    }
    // 存储来源
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      localStorage.removeItem('source')
      localStorage.removeItem('sourceExpiresAt')
    }
    // 提供给头部展示名称
    var regionSelJson = sessionStorage.getItem('regionSel')
    this.regionSelDetail = JSON.parse(regionSelJson)

    var regionselect = this.common.linkQuerys.type_id
    if (regionselect !== undefined && regionselect !== null && regionselect !== '') {
      this.region_select = regionselect
    }

    this.regionval = this.common.linkQuerys.region

    var regiontype = this.common.linkQuerys.type
    if (regiontype !== undefined && regiontype !== null && regiontype !== '' && !isNaN(regiontype)) {
      this.region_type = regiontype
    }
    this.start_date = this.common.linkQuerys.start_date
    this.end_date = this.common.linkQuerys.end_date
    var room = this.common.linkQuerys.room
    if (room !== undefined && room !== null && room !== '' && !isNaN(room)) {
      this.roomNum = room
    }
    var adult = this.common.linkQuerys.adult
    if (adult !== undefined && adult !== null && adult !== '' && !isNaN(adult)) {
      this.adultNum = adult
    }
    var child = this.common.linkQuerys.child
    if (child !== undefined && child !== null && child !== '' && !isNaN(child)) {
      this.childNum = child
    }
    var childNums = this.common.linkQuerys.childNums
    if (this.childNum !== undefined && this.childNum !== null && this.childNum !== '' && this.childNum > 0 && !isNaN(this.childNum)) {
      this.selecteds = []
      this.selecteds = childNums
    }
    var startdate = this.common.linkQuerys.start_date
    var enddate = this.common.linkQuerys.end_date
    if (startdate && enddate) {
      this.start_date = startdate
      this.end_date = enddate
    } else {
      var date1 = new Date()
      date1.setDate(date1.getDate())
      var date2 = new Date(date1)
      date2.setDate(date1.getDate() + 1)
      var start = (date1.getFullYear()) + '-' + (date1.getMonth() + 1) + '-' + (date1.getDate())
      var end = (date2.getFullYear()) + '-' + (date2.getMonth() + 1) + '-' + (date2.getDate())
      this.start_date = start
      this.end_date = end
    }
    // 默认列表-热门推荐
    var hotelType = this.common.linkQuerys.hotelType
    if (hotelType !== undefined && hotelType !== null && hotelType !== '') {
      this.hotelType = hotelType
      if (hotelType === 'low') {
        this.istop0 = false
        this.istop1 = true
        this.istop2 = false
      } else if (hotelType === 'high') {
        this.istop0 = false
        this.istop1 = false
        this.istop2 = true
      }
    }
    // keyword
    var keyword = this.common.linkQuerys.keyword
    if (keyword !== undefined && keyword !== null && keyword !== '') {
      this.keyword = keyword
    }
    this.getCurrencyList()
    this.refreshParams()
    this.getCity()
    this.getList(this.currentPage)
    // 下滑搜索条置顶
    window.addEventListener('scroll', this.handleScroll)

    if (document.body.clientWidth < 1001) {
      this.ismobile = true
    } else {
      this.ismobile = false
    }
  },
  destroyed () {
    window.name = ''
  },
  watch: {
    currency: function (newCur, oldCur) {
      this.getCurrencyList()
      this.getCity()
      this.getList(this.currentPage)
    },
    language: function (newCur, oldCur) {
      this.getCity()
      this.getList(this.currentPage)
      this.language = newCur
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.fromPath = from.path
      var fromname = from.name
      if (fromname !== null) {
        localStorage.setItem('keyword', JSON.stringify({}))
        localStorage.setItem('star', JSON.stringify([]))
        var budgetInfo = {'budget': [], 'budgetSelect': [], 'budgetSelectIds': []}
        localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
        localStorage.setItem('type', 'hot')
        localStorage.setItem('showSort', false)
        localStorage.setItem('showFilter', false)
      }
    })
  },
  methods: {
    hotelDetailCurrency (currency) {
      this.currency = currency
    },
    hotelLanguage (language) {
      this.language = language
    },
    // 下拉置顶
    handleScroll: function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 60) {
        this.hotelRoomSearchFixed = {'position': 'fixed', 'top': '0px', 'left': '0px', 'z-index': 1999}
        this.hotelRoomSearchFixedPlaceholder = {'display': 'block'}
      } else {
        this.hotelRoomSearchFixed = ''
        this.hotelRoomSearchFixedPlaceholder = ''
      }
    },
    refreshParams () {
      // var type = localStorage.getItem('type')
      // if (type !== null && type !== '') {
      //   this.hotelType = type
      //   if (this.hotelType === 'hot') {
      //     this.istop0 = true
      //     this.istop1 = false
      //     this.istop2 = false
      //   } else if (this.hotelType === 'low') {
      //     this.istop0 = false
      //     this.istop1 = true
      //     this.istop2 = false
      //   } else if (this.hotelType === 'high') {
      //     this.istop0 = false
      //     this.istop1 = false
      //     this.istop2 = true
      //   }
      // }
      // var showsort = localStorage.getItem('showSort')
      // if (showsort !== null && showsort !== '') {
      //   this.showSort = showsort
      // }
      // var params = {}
      // var searchData = localStorage.getItem('searchData')
      // if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
      //   params = JSON.parse(searchData)
      //   this.region_select = params.type_id
      //   this.region_type = params.type
      //   this.roomNum = params.room
      //   this.adultNum = params.adult
      //   this.childNum = params.child
      //   this.start_date = params.start_date
      //   this.end_date = params.end_date
      // }
      // var keyword = localStorage.getItem('keyword')
      // if (keyword !== '{}' && keyword !== null && keyword !== 'null' && keyword !== undefined && keyword !== '') {
      //   var keywordinfo = JSON.parse(keyword)
      //   this.keyword = keywordinfo.keyword
      //   this.cityid = keywordinfo.cityid
      //   this.countryid = keywordinfo.countryid
      // }
      var star = localStorage.getItem('star')
      if (star !== null && star !== '') {
        this.checkedLevel = JSON.parse(star)
        this.checkedLevel.forEach((item, index) => {
          this.selectLevelConds.push(this.common.levelOptions[ item ])
        })
        this.selectConds = this.selectLevelConds.concat(this.selectBudgetConds)
        this.condNum = this.selectConds.length
      }
      var budgetInfo = localStorage.getItem('budgetInfo')
      if (budgetInfo !== null && budgetInfo !== '') {
        var budgetArr = JSON.parse(budgetInfo)
        var budget = budgetArr['budget']
        this.checkedBudget = budget
        this.selectBudgetConds = budgetArr['budgetSelect']
        this.budgetSelectIds = budgetArr['budgetSelectIds']
        this.selectConds = this.selectLevelConds.concat(this.selectBudgetConds)
        this.condNum = this.selectConds.length
        if (this.checkedBudget.length > 1) {
          budget.sort()
          var num = parseInt(budget[ budget.length - 1 ]) - parseInt(budget[ 0 ])
          if (num > 1) {
            var i
            for (i = 1; i < num; i++) {
              var id = parseInt(budget[ 0 ]) + i
              this.budgetNo[ id ] = true
            }
          }
        }
      }
      // var page = localStorage.getItem('page')
      // if (page !== null && page !== '') {
      //   this.currentPage = parseInt(page)
      //   if (this.currentPage > 1) {
      //     var nolist = localStorage.getItem('noListInfo')
      //     if (nolist !== {} && nolist !== '') {
      //       this.noListInfo = JSON.parse(nolist)
      //     }
      //     var total = localStorage.getItem('total')
      //     if (total !== {} && total !== '' && total !== 0) {
      //       this.listTotal = parseInt(total)
      //     }
      //   }
      // }
      var showFilter = localStorage.getItem('showFilter')
      if (showFilter !== null && showFilter !== '') {
        this.showFilter = showFilter
      }
    },
    handlecheckedLevelChange (value) {
      let surplusLevelSelectConds = []
      if (this.selectLevelConds.length < value.length) {
        // 选择星级操作记录埋点
        // this.clickPageAction('star_filter', this.common.levelOptions[ value[ value.length - 1 ] ], {'type': 'add'})

        this.selectLevelConds.push(this.common.levelOptions[ value[ value.length - 1 ] ])
      } else {
        value.forEach((item, index) => {
          surplusLevelSelectConds.push(this.common.levelOptions[item])
        })
        if (surplusLevelSelectConds === '' || surplusLevelSelectConds === null) {
          this.selectLevelConds = []
        } else {
          this.selectLevelConds.forEach((item, index) => {
            if (!surplusLevelSelectConds.includes(item)) {
              // 选择星级操作记录埋点
              // this.clickPageAction('star_filter', item, {'type': 'less'})

              this.selectLevelConds.splice(this.selectLevelConds.indexOf(item), 1)
            }
          })
        }
      }
      this.selectConds = this.selectLevelConds.concat(this.selectBudgetConds)
      this.condNum = this.selectConds.length
      localStorage.setItem('star', JSON.stringify(this.checkedLevel))

      // 选择星级操作记录埋点
      var selectStar = []
      this.selectLevelConds.forEach((item, index) => {
        selectStar.push(item.split('/')['0'])
      })
      this.clickPageAction('star_filter', '', selectStar)

      this.getList(1)
    },
    handleCheckedBudgetChange (value) {
      let surplusBudgetSelectConds = []
      // 勾选
      if (this.budgetSelectIds.length < value.length) {
        // console.log('budgets add' + this.budgets[ value[ value.length - 1 ] ])
        // 选择价格操作记录埋点
        this.clickPageAction('price_filter', this.budgets[ value[ value.length - 1 ] ], {'type': 'add'})

        this.selectBudgetConds.push(this.budgets[ value[ value.length - 1 ] ])
        this.budgetSelectIds.push(value[ value.length - 1 ])
        if (value.length > 1) {
          value.sort()
          var num = parseInt(value[ value.length - 1 ]) - parseInt(value[ 0 ])
          if (num > 1) {
            var i
            for (i = 1; i < num; i++) {
              var id = parseInt(value[ 0 ]) + i
              this.budgetSelectIds.push(id.toString())
              this.budgetNo[ id ] = true
              this.checkedBudget.push(id.toString())
              if (this.selectBudgetConds.includes(this.budgets[ id ])) {
                this.selectBudgetConds.splice(this.selectConds.indexOf(this.budgets[ id ]), 1)
              }
            }
          }
        }
      } else {
        value.forEach((item, index) => {
          surplusBudgetSelectConds.push(this.budgets[ item ])
        })

        // 取消勾选后，没有任何勾选
        if (surplusBudgetSelectConds === '' || surplusBudgetSelectConds === null || surplusBudgetSelectConds.length === 0) {
          this.selectBudgetConds.forEach((item, index) => {
            // console.log('budgets less: ' + item)
            // 选择价格操作记录埋点
            this.clickPageAction('price_filter', item, {'type': 'less'})
          })

          this.selectBudgetConds = []
          this.checkedBudget = []
          this.budgetSelectIds = []
        } else {
          // 取消勾选后，还有其他勾选
          this.selectBudgetConds.forEach((item, index) => {
            if (!surplusBudgetSelectConds.includes(item)) {
              // console.log('budgets less' + item)
              // 选择价格操作记录埋点
              this.clickPageAction('price_filter', item, {'type': 'less'})

              var cancelid = this.budgetsRev[ item ]
              this.budgetSelectIds.sort()
              var min = this.budgetSelectIds[ 0 ]
              var max = this.budgetSelectIds[ this.budgetSelectIds.length - 1 ]
              // 如果取消的是最小值，则只保留最大值
              if (parseInt(cancelid) === parseInt(min)) {
                // 取最大值
                this.selectBudgetConds = [ this.budgets[ max ] ]
                this.checkedBudget = [ max.toString() ]
                this.budgetSelectIds = [ max.toString() ]
              } else {
                // 如果取消的是最大值，则只保留最小值
                this.selectBudgetConds = [ this.budgets[ min ] ]
                this.checkedBudget = [ min.toString() ]
                this.budgetSelectIds = [ min.toString() ]
              }
              this.budgetNo = {5: false, 6: false, 7: false, 8: false, 9: false}
            }
          })
        }
      }
      this.selectConds = this.selectLevelConds.concat(this.selectBudgetConds)
      this.condNum = this.selectConds.length
      var budgetInfo = {'budget': this.checkedBudget, 'budgetSelect': this.selectBudgetConds, 'budgetSelectIds': this.budgetSelectIds}
      localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
      this.getList(1)
    },
    tagClose (tag) {
      if (this.selectLevelConds.includes(tag)) {
        this.selectLevelConds.splice(this.selectConds.indexOf(tag), 1)
        this.checkedLevel.splice(this.checkedLevel.indexOf(this.common.levelOptionsRev[tag]), 1)

        // 埋点
        var selectStar = []
        this.selectLevelConds.forEach((item, index) => {
          selectStar.push(item.split('/')['0'])
        })
        this.clickPageAction('star_type', tag, selectStar)
      }
      if (this.selectBudgetConds.includes(tag)) {
        // 点击排序埋点记录
        this.clickPageAction('price_type', tag, {'type': 'less', 'palace': 'top'})

        this.selectBudgetConds.splice(this.selectConds.indexOf(tag), 1)
        if (this.selectBudgetConds.length > 0) {
          // 如果删除后，还有 其他价格范围已勾选
          var id = this.budgetsRev[ this.selectBudgetConds[ 0 ] ]
          this.checkedBudget = [ id.toString() ]
          this.budgetSelectIds = [ id ]
        } else {
          // 如果删除后，没有 其他价格范围已勾选
          this.selectBudgetConds = []
          this.checkedBudget = []
          this.budgetSelectIds = []
        }
      }
      this.selectConds.splice(this.selectConds.indexOf(tag), 1)
      this.budgetNo = {5: false, 6: false, 7: false, 8: false, 9: false}
      this.condNum -= 1
      localStorage.setItem('star', JSON.stringify(this.checkedLevel))
      var budgetInfo = {'budget': this.checkedBudget, 'budgetSelect': this.selectBudgetConds, 'budgetSelectIds': this.budgetSelectIds}
      localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
      this.getList(1)
    },
    closeAll () {
      // 点击排序埋点记录
      this.clickPageAction('price_type', 'close-all', {'type': 'less', 'palace': 'top'})

      if (this.condNum > 0) {
        this.selectConds = []
        this.checkedLevel = []
        this.checkedBudget = []
        this.selectLevelConds = []
        this.selectBudgetConds = []
        this.budgetSelectIds = []
        this.condNum = 0
        this.budgetNo = {5: false, 6: false, 7: false, 8: false, 9: false}
        localStorage.setItem('star', JSON.stringify(this.checkedLevel))
        var budgetInfo = {'budget': this.checkedBudget, 'budgetSelect': this.selectBudgetConds, 'budgetSelectIds': this.budgetSelectIds}
        localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
        this.getList(1)
      }
    },
    // hot：热门推荐 low：价低优先 high：高星优先
    clickistop (type, title) {
      // 点击排序埋点记录
      this.clickPageAction('price_type', type, {'sort': type})

      this.hotelType = type
      if (type === 'hot') {
        this.istop0 = true
        this.istop1 = false
        this.istop2 = false
      } else if (type === 'low') {
        this.istop0 = false
        this.istop1 = true
        this.istop2 = false
      } else if (type === 'high') {
        this.istop0 = false
        this.istop1 = false
        this.istop2 = true
      }
      var query = JSON.parse(JSON.stringify(this.common.linkQuerys))
      query.hotelType = this.hotelType

      // this.$router.push({path: '/hotelsearch/TextHotelList', query: query})
      var newQuerys = this.common.linkEncode(query, 'obj')
      this.$router.push({path: '/hotelsearch/TextHotelList/' + newQuerys})

      localStorage.setItem('type', type)
      this.showSort = true
      localStorage.setItem('showSort', this.showSort)
      this.viewSort = false
      // if (this.condNum > 0) {
      //   this.selectConds = []
      //   this.checkedLevel = []
      //   this.checkedBudget = []
      //   this.selectLevelConds = []
      //   this.selectBudgetConds = []
      //   this.budgetSelectIds = []
      //   this.condNum = 0
      //   this.budgetNo = {5: false, 6: false, 7: false, 8: false, 9: false}
      //   localStorage.setItem('star', JSON.stringify(this.checkedLevel))
      //   var budgetInfo = {'budget': this.checkedBudget, 'budgetSelect': this.selectBudgetConds, 'budgetSelectIds': this.budgetSelectIds}
      //   localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
      // }
      this.getList(1)
    },
    roomAdd () {
      if (this.roomNum < 10) {
        this.roomNum += 1
        this.roomLessDo = true
        this.roomInfo = this.roomNum + '间客房'
        if (this.roomNum > this.adultNum) {
          this.adultNum = this.roomNum
          this.adultLessDo = true
          this.personInfo = this.adultNum + '名大人'
        }
      } else {
        this.roomAddNoDo = true
      }
    },
    roomLess () {
      if (this.roomNum > 1) {
        this.roomNum -= 1
        if (this.roomNum === 1) {
          this.roomLessDo = false
        }
        this.roomInfo = this.roomNum + '间客房'
      }
      if (this.roomNum < 10) {
        this.roomAddNoDo = false
      }
    },
    adultAdd () {
      this.adultNum += 1
      this.adultLessDo = true
      this.personInfo = this.adultNum + '名大人'
    },
    adultLess () {
      if (this.adultNum > 1) {
        this.adultNum -= 1
        if (this.adultNum === 1) {
          this.adultLessDo = false
        }
        this.personInfo = this.adultNum + '名大人'
        if (this.roomNum > this.adultNum) {
          this.roomNum = this.adultNum
          this.roomInfo = this.roomNum + '间客房'
          if (this.roomNum === 1) {
            this.roomLessDo = false
          }
          if (this.roomNum < 10) {
            this.roomAddNoDo = false
          }
        }
      }
    },
    childAdd () {
      if (this.childNum < 10) {
        this.childNum += 1
        this.childLessDo = true
        this.personInfo = this.adultNum + '名大人,' + this.childNum + '名儿童'
      } else {
        this.childAddNoDo = true
      }
      if (this.childNum === 1) {
        this.showChildInfo = true
      }
    },
    childLess () {
      if (this.childNum > 0) {
        this.childNum -= 1
        this.personInfo = this.adultNum + '名大人,' + this.childNum + '名儿童'
        if (this.childNum === 0) {
          this.childLessDo = false
          this.personInfo = this.adultNum + '名大人'
        }
      }
      if (this.roomNum < 10) {
        this.childAddNoDo = false
      }
      if (this.childNum === 0) {
        this.showChildInfo = false
      }
    },
    showPerson () {
      if (this.showPersonInfo === false) {
        this.showPersonInfo = true
      } else {
        this.showPersonInfo = false
      }
    },
    // 分页 size-change  pageSize 改变时会触发 每页条数
    handleSizeChange (val) {
      this.pageSize = val
    },
    // current-change  currentPage 改变时会触发  当前页
    async handleCurrentChange (val) {
      this.start = (val - 1) * this.pageSize // （val-1）是我自己的项目需要，一般写val即可
      localStorage.setItem('page', val)
      this.getList(val)
    },
    getCity () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'region_type': this.region_type,
        'region': this.region_select,
        'time': time,
        'language': this.language,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getCityInfo(data).then(res => {
        if (res.flag === '200') {
          this.country = res.data.countryname
          this.city = res.data.cityname
          this.countryid = res.data.country_id
          this.cityid = res.data.city_id
          this.cityData = {
            'city_type_id': res.data.city_type_id,
            'city_type_en': res.data.city_type_en,
            'city_type_zh': res.data.city_type_zh
          }
        }
      })
    },
    getList (page) {
      document.querySelector('#main').scrollIntoView({
        behavior: 'smooth'
      })
      this.listInfo = []
      this.cotentShow = true
      this.stopScroll()
      // hot：热门推荐 low：价低优先 high：高星优先
      // const loading = this.$loading({
      //   lock: true,
      //   text: '酒店加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })

      if (this.start_date === this.end_date) {
        var endDate = new Date(this.start_date)
        var endDateMonth = ((endDate.getMonth() + 1) < 10) ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)
        this.end_date = (endDate.getFullYear()) + '-' + endDateMonth + '-' + (endDate.getDate() + 1)
      }

      // 被搜索到的酒店
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        token = ''
      }
      // var sessionid = this.common.sessionidGet(this)
      if (page === 1 || page === '1') {
        this.mustTotal = 0
      }
      console.log(sessionStorage.getItem('regionSel'))

      var regionSelJson = sessionStorage.getItem('regionSel')
      var region = ''
      if (regionSelJson !== undefined && regionSelJson !== null) {
        var regionSelArr = JSON.parse(regionSelJson)
        if (this.language === 'zh') {
          region = regionSelArr.value_zh
        } else {
          region = regionSelArr.value_en
        }
      }
      var dataJson = {
        'region_keyword': region,
        'keyword': this.keyword,
        'type': this.hotelType,
        'region_type': this.region_type,
        'region': this.region_select,
        'start_date': this.start_date,
        'end_date': this.end_date,
        'room': this.roomNum,
        'adult': this.adultNum,
        'child': this.childNum,
        'childNums': this.selecteds,
        'star': this.checkedLevel,
        'budget': this.checkedBudget,
        'page': page,
        'time': time,
        'language': this.language,
        'currency': this.currency,
        'token': token,
        // 'sessionid': sessionid,
        'source': this.source,
        'mustcount': this.mustTotal
      }
      // if (this.keyword.length) {
      //   dataJson['countryid'] = this.countryid
      //   dataJson['cityid'] = this.cityid
      // }
      if (page > 1) {
        dataJson['nolist'] = this.noListInfo
        dataJson['mustcount'] = this.mustTotal
      }
      var data = this.common.encryptionData(dataJson, this)
      texthotelList(data).then(res => {
        if (res.flag === '200' || res.flag === '201') {
          this.listInfo = res.data.hotellist
          this.noListInfo = res.data.nohotellist
          this.listCurrency = res.data.currency
          localStorage.setItem('noListInfo', JSON.stringify(this.noListInfo))
          this.listTotal = parseInt(res.data.totalNum)
          localStorage.setItem('total', this.listTotal)
          this.listTotalAll = parseInt(res.data.totalNumAll)
          this.currentPage = parseInt(res.data.currentPage)
          this.pageSize = parseInt(res.data.pageSize)
          this.cotentShow = false
          this.cotentEmptyShow = false
          this.mustTotal = parseInt(res.data.mustcount)
        } else if (res.flag === '112') {
          this.cotentShow = false
          this.cotentEmptyShow = true
        } else {
          this.cotentShow = false
          this.cotentEmptyShow = true
        }
        this.canScroll()
        // loading.close()
        this.frameQuotationDialog = false

        return res
      }).then(res => {
        if (this.listInfo.length !== '0') {
          this.hotelFirstData = this.listInfo[0]
        }

        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(data, res, requestTime, responseTime)
        })
      })
    },
    querySearch (queryString, cb) {
      cb(this.restaurants)
    },
    handleSelect (item) {
      this.region_select = item.id
    },
    closepopEven: function (type) {
      if (type === 'hotelSearchStar') {
        this.hotelSearchStar = false
      }
    },
    getSearchInfo (val) {
      this.region_select = val['type_id']
      this.region_type = val['type']
      this.start_date = val['start_date']
      this.end_date = val['end_date']
      this.roomNum = val['room']
      this.adultNum = val['adult']
      this.childNum = val['child']
      this.state = val['region']
      this.selecteds = val['childNums']
      this.keyword = ''
      this.search_json['region'] = val['region']
      this.search_json['type'] = val['type']
      this.search_json['type_id'] = val['type_id']
      this.search_json['start_date'] = val['start_date']
      this.search_json['end_date'] = val['end_date']
      this.search_json['room'] = this.roomNum
      this.search_json['adult'] = this.adultNum
      this.search_json['child'] = this.childNum
      this.search_json['childNums'] = this.selecteds
      localStorage.setItem('searchData', JSON.stringify(this.search_json))
      this.keyword_json['keyword'] = this.keyword
      this.keyword_json['cityid'] = 0
      this.keyword_json['countryid'] = 0
      localStorage.setItem('keyword', JSON.stringify(this.keyword_json))
      var dates = {'startdate': this.start_date, 'enddate': this.end_date}
      localStorage.setItem('noListInfo', JSON.stringify({}))
      localStorage.setItem('total', 0)
      this.selectConds = []
      this.checkedLevel = []
      this.checkedBudget = []
      this.selectLevelConds = []
      this.selectBudgetConds = []
      this.budgetSelectIds = []
      this.condNum = 0
      this.budgetNo = {5: false, 6: false, 7: false, 8: false, 9: false}
      localStorage.setItem('star', JSON.stringify(this.checkedLevel))
      var budgetInfo = {'budget': this.checkedBudget, 'budgetSelect': this.selectBudgetConds, 'budgetSelectIds': this.budgetSelectIds}
      localStorage.setItem('budgetInfo', JSON.stringify(budgetInfo))
      localStorage.setItem('dates', dates)
      localStorage.setItem('page', 1)
      localStorage.setItem('showFilter', false)
      localStorage.setItem('showSort', false)
      this.getCity()
      this.frameQuotationDialog = true

      var query = JSON.parse(JSON.stringify(this.common.linkQuerys))
      query.hotelType = ''
      query.keyword = ''
      query.type = val['type']
      query.type_id = val['type_id']
      query.region = val['region']
      query.start_date = val['start_date']
      query.end_date = val['end_date']
      query.room = val['room']
      query.adult = val['adult']
      query.child = val['child']
      query.childNums = val['childNums']

      // this.$router.push({path: '/hotelsearch/TextHotelList', query: query})
      var newQuerys = this.common.linkEncode(query, 'obj')
      this.$router.push({path: '/hotelsearch/TextHotelList/' + newQuerys})

      this.getList(1)
    },
    getSearchStar (val) {
      var level = val['level']
      var budget = val['budget']
      if (level.length > 0 || budget.length > 0) {
        this.showFilter = true
      } else {
        this.showFilter = false
      }
      localStorage.setItem('showFilter', this.showFilter)
      this.checkedLevel = level
      this.checkedBudget = budget
      this.getList(1)
    },
    // closeLevel () {
    //   this.showLevel = false
    //   this.$refs.child.checkedLevel = [] // 修改子组件data
    //   this.checkedLevel = []
    //   this.getList(1)
    // },
    // closeBudget () {
    //   this.showBudget = false
    //   this.$refs.child.checkedBudget = []
    //   var budget = {5: false, 6: false, 7: false, 8: false, 9: false}
    //   this.$refs.child.budgetNo = budget
    //   this.checkedBudget = []
    //   this.budgetNo = budget
    //   this.getList(1)
    // },
    collect (listname, key, hotelid, islike) {
      var dolike = parseInt(islike) === 1 ? 0 : 1
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)

        // this.$router.push({name: 'login', query: {'source': this.source}})
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      this.listInfo[key]['islike'] = dolike
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'hotelid': hotelid, 'status': dolike, 'token': token, 'time': time, 'language': this.language, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)

      // 收藏酒店埋点记录
      this.clickPageAction('hotel_collect', '', data)

      doCollect(data).then(res => {
        if (res.flag === '001') {
          // this.$router.push({name: 'login', query: {'source': this.source}})
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '141') {
          this.remindFaild = true
          this.remindMessage = res.msg
          this.listInfo[key]['islike'] = islike
        }
        return res
      })
    },
    getCurrencyList () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'currency': this.currency, 'language': this.language, 'time': time, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)
      hotelCurrency(data).then(res => {
        this.budgets = res.budgets
        this.budgetsRev = res.budgetsRev
        this.oldBudgetsRev = res.oldBudgetsRev
        this.$refs.child.budgets = res.budgets
        this.$refs.child.budgetsRev = res.budgetsRev
        this.$refs.child.oldBudgetsRev = res.oldBudgetsRev
      })
    },
    handleKeyUp () {
      this.keyword_json['keyword'] = this.keyword
      this.keyword_json['cityid'] = this.cityid
      this.keyword_json['countryid'] = this.countryid
      localStorage.setItem('keyword', JSON.stringify(this.keyword_json))

      var query = JSON.parse(JSON.stringify(this.common.linkQuerys))
      query.keyword = this.keyword
      // this.$router.push({path: '/hotelsearch/TextHotelList', query: query})
      var newQuerys = this.common.linkEncode(query, 'obj')
      this.$router.push({path: '/hotelsearch/TextHotelList/' + newQuerys})
      this.getList(1)
    },
    propertyClassLanguage (key) {
      return this.$t(this.common.propertyLanguage[key])
    },
    gotoDetail (hotelid, name, startdate, enddate, roomNum, adultNum, childNum) {
      var detailjson = {}
      detailjson['hotelid'] = hotelid
      detailjson['region'] = name
      detailjson['start_date'] = startdate
      detailjson['end_date'] = enddate
      detailjson['room'] = roomNum
      detailjson['adult'] = adultNum
      detailjson['child'] = childNum
      detailjson['childNums'] = this.selecteds
      detailjson['language'] = this.language
      detailjson['currency'] = this.currency
      if (this.source !== '' && this.source !== 'roompai' && this.source !== undefined && this.source !== null) {
        detailjson['source'] = this.source
      }

      // 选择客房操作记录
      this.clickPageAction('select_room', '', detailjson)

      // this.$router.push({name: 'HotelDetail', query: detailjson})
      var newQuerys = this.common.linkEncode(detailjson, 'obj')
      this.$router.push({name: 'HotelDetail', params: {'querys': newQuerys}})
    },
    focusDate: function (hotelid, hotelData) {
      if (this.common.languageSet(this) === 'zh') {
        this.$refs.childCond.state = hotelData.hotelname_zh
      } else {
        this.$refs.childCond.state = hotelData.hotelname
      }
      this.$refs.childCond.region_select = hotelid
      this.$refs.childCond.region_type = 3

      var regionSel = {'value_zh': hotelData.hotelname_zh, 'value_en': hotelData.hotelname, 'type_id': 3, 'type_data_id': hotelid}
      // 保留选择的目的地
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      // 更改日期操作记录埋点
      this.clickPageAction('hotel_change_date', hotelid, {'hotelid': hotelid})

      if (document.body.clientWidth < 1001) {
        // 尺寸如果低于1001 则触发frame
        this.$refs.childCond.hotelSearchFrame = true
      } else {
        // 尺寸如果高于1001
        this.$refs.childCond.parentFocus()
        document.querySelector('#main').scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    rollToFirst (hotelid) {
      // 查看别的酒店 埋点记录
      this.clickPageAction('change_hotel', hotelid, {'hotelid': hotelid})

      document.querySelector('#right').scrollIntoView({
        behavior: 'smooth'
      })
    },
    selectHotelList: function () {
      // var regionselect = this.$refs.child.region_select
      var startdate = this.start_date
      var enddate = this.end_date
      var room = this.roomNum
      var adult = this.adultNum
      var child = this.childNum

      var regionSel = {'value_en': this.cityData.city_type_en, 'value_zh': this.cityData.city_type_zh, 'type_id': 1, 'type_data_id': this.cityData.city_type_id}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var language = this.common.languageSet(this)
      var cityRegion = this.cityData.city_type_en
      if (language === 'zh') {
        cityRegion = this.cityData.city_type_zh
      }

      var childNums = '[]'
      var searchData = localStorage.getItem('searchData')
      if (searchData !== '{}' && searchData !== null) {
        var params = JSON.parse(searchData)
        childNums = params.childNums
      }
      var searchJson = {'type': 1, 'type_id': this.cityData.city_type_id, 'region': cityRegion, 'start_date': startdate, 'end_date': enddate, 'room': room, 'adult': adult, 'child': child, 'childNums': childNums}
      if (this.source !== '' && this.source !== 'roompai' && this.source !== undefined && this.source !== null) {
        searchJson['source'] = this.source
      }
      localStorage.setItem('searchData', JSON.stringify(searchJson))

      // this.$router.push({name: 'TextHotelList', query: searchJson})
      var newQuerys = this.common.linkEncode(searchJson, 'obj')
      this.$router.push({name: 'TextHotelList', params: {'querys': newQuerys}})

      this.timer = new Date().getTime()
      this.region_select = this.cityData.city_type_id
      this.region_type = 1
      this.getList(1)
    },
    stopScroll () {
      var mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', mo, false)
    },
    canScroll () {
      var mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = ''
      document.addEventListener('touchmove', mo, false)
    }
  }
}
</script>

<style scoped>
.hotellist-main /deep/ .el-header {
  position: unset;
}
.nearby{ border:1px solid red !important;}
.order{ border:1px solid blue !important;}
.collect{ border:1px solid green !important;}
.el-main{text-align: left;}
.main{background-color: #fff;width:100%;}

/* 搜索条件 开始 */
/* .list-search{width: 100%;height: 64px;-ms-overflow-x: hidden;overflow-x: hidden;-ms-overflow-y: hidden;overflow-y: hidden;background-color: rgba(79, 76, 76, 1);margin: 0 auto;line-height: 64px;}
.location-search{height:48px;line-height:64px;margin: 0 auto;} */
.list-content{margin: 0 auto;}
/* 目的地 */
/* .input-region{width: 361px; height: 48px;} */
.hotellist-region /deep/ .el-input__inner{padding: 0 60px;height: 48px; background-image: url(https://res.roompai.com/static/img/input-region.png);background-repeat: no-repeat;background-size: 23px;background-position: 15px center;}
.location-search .hotellist-region{width:35%;}
.el-autocomplete{width:100%;}
/* .el-autocomplete /deep/ .el-input__inner{ font-size: 16px;} */
.hotellist-region input{background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-region.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;font-size: 16px;opacity:1;}
.hotellist-region input:focus,.hotellist-date.el-range-editor.is-active, .hotellist-date.el-range-editor.is-active:focus{border-color:#FFCE00;box-shadow: 0 2px 4px 0 #ecd269, 0 0 6px 0 #ecd269;}
.my-autocomplete .name {height:25px;text-overflow: ellipsis;overflow: hidden;font-weight: 650; color:#4F4C4C;}
.my-autocomplete .addr {height:25px;font-weight: 100;color: #4F4C4C;}
.my-autocomplete .highlighted .addr {color: #ddd;}
/* 日期 */
.hotellist-date{padding: 0px 50px;width: 30%; height: 48px;font-size: 16px;opacity:1;}
.el-range-editor.el-input__inner{display:inline-block;}
.el-date-editor--daterange.el-input__inner{ width:30%;}
.input-date-icon{background-image:url(https://res.roompai.com/static/img/input-date.png);background-repeat:no-repeat;background-size: 23px;background-position: 0px center;}
.hotellist-date .el-range__icon{margin-left:0px;}

/* 入住人 */
.person-inner{border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;line-height: 20px;outline: 0;margin: 0em;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/input-person.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;opacity:1; cursor: pointer;}
.inphotellistut-person .person-inner:hover{border-color:#FFCE00;}
/* .el-select-dropdown{display:none;} */
.personLessno{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png"); border: none; background-color: #fff;}
.personLessno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png")}
.personLess{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
.personLess:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-less-20x20.png");}
.personnum{position: relative;display: inline-block;width: 224px;line-height: 38px;text-align: center;}
.personAdd{width: 32px;height: 32px;vertical-align:middle;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-20x20.png");border: none; background-color: #fff;}
.personAdd:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-20x20.png");}
.personAddno{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png");}
.personAddno:hover{background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-add-20x20.png")}
.personnum span{display:inline-block;}
.personnum input{border:none;outline:none;width:20px;height:32px;color:#409EFF;font-weight: 400; font-size: 18px;}
.personnum input:focus{border:0;outline:none;width:20px;height:32px;}
.spantext{color:#999999; font-size: 14px;}
.select-person{display:inline-block; width:20%;vertical-align: -webkit-baseline-middle;}
.showPersonBorder{border-color:#FFCE00;box-shadow: 0 2px 4px 0 #ecd269, 0 0 6px 0 #ecd269;}
.showPersonBorder:hover{border-color:#FFCE00;}
.personText{font-weight: 650; font-size:14px;color: #4F4C4C;display:block;white-space: nowrap;overflow: hidden;}
.roomText{font-size:14px;color: #999999;white-space: nowrap;overflow: hidden;}
.childinfo .el-select-dropdown,.el-select-dropdown{display:block}
.selectOld{width: 40%;float: left;margin-left: 5%; margin-top: -7%;}
/* 加减成人 */
.personLessno{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/bfbfbf-20x20.png");}
.personLess{width: 32px;height: 32px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
/* 入住人选择 */
.personInfo{border-width: 0px;position: absolute;left: 61.2%;width: 224px;height: auto;background: inherit;background-color: rgba(255, 255, 255, 1);border: none;border-radius: 4px;-moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.09803921568627451);-webkit-box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);box-shadow: 0px 2px 12px rgb(0 0 0 / 10%); color: #999999;font-size: 14px;}
/* 搜索 */
.hotellist_button{cursor: pointer; width:12%;height:48px;font-size:16px;background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
.hotellist_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(252, 210, 5, 1);}
.hotellist_button:focus{background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
/* 搜索条件 结束 */
/* 手机版 */
  .location-search-mobile {width:95%;height:64px;line-height:64px;margin: 8px auto;}
  .mobile-search{border-radius: 4px;border: 1px solid #DCDFE6;box-sizing: border-box;color: #606266;display: inline-block;font-size: inherit;line-height: 20px;outline: 0;margin: 0em;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/hotelsearch/4F4C4C.png);background-repeat:no-repeat;background-size: 23px;background-position: 15px center;padding: 0px 50px;width: 100%; height: 48px;opacity:1; cursor: pointer;}
.mobile-search:hover{border-color:#FFCE00;}
.mobile-keyword-search{display: inline-block;}
.mobile-keyword-search input{float:right;height:40px;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/hotelsearch/2-4F4C4C.png);background-repeat:no-repeat;background-size: 20px;background-position: 15px center;padding: 0px 50px;font-size: 14px;opacity:1;border:1px solid rgba(221, 223, 226, 1);}
.list-top{height:40px;}
.top-search{vertical-align: -webkit-baseline-middle;margin: 10px 0px 9.3px 0px;color:rgba(83, 146, 249, 1);}
.cond-search{vertical-align: -webkit-baseline-middle;margin-top: 20px;color:#fff;background-color:rgba(83, 146, 249, 1);}
.blue-search,.blue-search:hover,.blue-search:focus{color:#fff !important;background-color:rgba(83, 146, 249, 1) !important;border: 1px solid rgba(83, 146, 249, 1);}
.blue-text{color:#5392F9;}
.el-icon-s-operation{margin-right: 2px;}
.el-icon-caret-bottom{margin-left:2px;}
.el-button:focus, .el-button:hover,.el-select .el-input.is-focus .el-input__inner{border:1px solid #DCDFE6;background: #FFF;}
.el-button+.el-button{margin-left: 0px;}
/* 手机版 */

/* 搜索结果 开始 */
/* 导航 */
.directory{height:46px;width:100%;font-size: 12px;text-align: left;line-height: 46px;}
.directory a{text-decoration:none;color: #4F4C4C;}
.slash{color: #C0C4CC;padding:0px 5px 0px 5px;}
/* 细致搜索 */
.list-search-all{height:auto;}
.list-left{width:25%;float: left;}
/* 左侧搜索 */
.icon-search{background-image: ("https://res.roompai.com/static/img/hotelsearch/4F4C4C.png");width:20px;height: 20px;}
/* .keyword-search img{position: absolute;transform: translateX(-120px);margin-top: 10px;margin-left: 10px;height: 20px;width: 20px;} */
.keyword-search input{height:40px;background-color:rgba(255,255,255,1);background-image:url(https://res.roompai.com/static/img/hotelsearch/2-4F4C4C.png);background-repeat:no-repeat;background-size: 20px;background-position: 15px center;padding: 0px 50px;width: 95%; font-size: 14px;opacity:1;border:1px solid rgba(221, 223, 226, 1);}

/* 星级筛选 和 您的预算*/
.starsearch{margin-top:28px;font-size: 18px;float: left;height: 200px;width:100%;}
.starlevel{font-weight: 200;color: #4F4C4C;font-size: 14px;margin-top:5px;display: block;}
.el-checkbox{margin-top:20px;font-weight: 200;display: block;}

/* 右侧结果 */
.list-right{width:75%;float: left;}
.list-right .el-tag{margin-left: 10px;background-color: rgba(79, 76, 76, 1);border-color: rgba(79, 76, 76, 1);color: #FCD205;height: 32px;padding: 0 10px;line-height: 30px;font-size: 12px;font-weight: 400;border-width: 1px;border-style: solid;border-radius: 39px;-webkit-box-sizing: border-box;box-sizing: border-box;white-space: nowrap;}
.imgclose{width: 12px;height: 12px;padding-left: 4px;margin-bottom: -1px;cursor:pointer;}
.closeAll{font-size: 12px;color: #4F4C4C;cursor: pointer;padding: 0 10px 0 14px;display: inline-block;}
.closeAll:hover{text-decoration:underline;color: rgb(102,177,255);}
.condNum{font-size: 14px;font-weight: 650;color: #5392F9;}
.content{margin-top:20px;width:100%; min-height:600px;}
.content-empty{height: 400px;text-align: center;padding-top: 40px;}
.content /deep/ .el-card{border: none;}
.content /deep/ .el-card.is-always-shadow, .content /deep/ .el-card.is-hover-shadow:focus, .content /deep/ .el-card.is-hover-shadow:hover{box-shadow: none;-webkit-box-shadow:none;}
/* 热门推荐 价低优先 高星优先 */
.tagAll{display:block;}
.top{border: 1px solid rgba(221, 223, 226, 1);box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%);border-radius: 4px;width: 100%;height: 40px;font-weight: 650;font-style: normal;font-size: 0;line-height: 40px;text-align: center;}
.istop-0{display: inline-block;border-right: 1px solid rgba(221, 223, 226, 1);width: 34%;height: 40px;box-sizing: border-box;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;cursor: pointer;font-size: 14px;}
.istop-1{display: inline-block;width: 33%;height: 40px;cursor: pointer;font-size: 14px;}
.istop-2{display: inline-block;border-left: 1px solid rgba(221, 223, 226, 1);width: 32.999%;height: 40px;box-sizing: border-box;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;cursor: pointer;font-size: 14px;}
.istop-select-0{border-radius: 4px;border-top-right-radius: 0px;border-bottom-right-radius: 0px;background-color: rgba(83, 146, 249, 1);color: rgb(255, 255, 255);}
.istop-select-1{background-color: rgba(83, 146, 249, 1);color: rgb(255, 255, 255);}
.istop-0:hover,.istop-1:hover,.istop-2:hover{color:rgba(83, 146, 249, 1);}
.istop-select-0:hover,.istop-select-1:hover,.istop-select-2:hover{color:rgb(255, 255, 255);}
.istop-select-2{border-radius: 4px;border-top-left-radius: 0px;border-bottom-left-radius: 0px;background-color: rgba(83, 146, 249, 1);color: rgb(255, 255, 255);}

/* 酒店列表 */
.match-hotel{height: 40px; background: inherit; background-color: rgba(83, 146, 249, 0.9215686274509803); border: none; border-radius: 10px; border-bottom-right-radius: 0px; border-bottom-left-radius: 0px; -moz-box-shadow: none; -webkit-box-shadow: none; box-shadow: none; margin-bottom: -15px; margin-top: 15px; font-weight: 500; font-style: normal; font-size: 16px; color: #FFFFFF; line-height: 40px; padding-left: 10px;}
.hotellist{margin-top: 15px;border: 1px solid rgba(221, 223, 226, 1);border-radius: 4px;height: 207px;cursor: pointer;}
.hotellist:hover{box-shadow: 0px 6px 12px rgb(0 0 0 / 20%); border: 1px solid rgb(0 0 0 / 5%);height: 207px;margin-top: 15px;border-radius: 4px;}
.hotelImgs{display: inline-block;height: 207px;width: 33%;float: left;position: relative;top:0px;left:0px;}
.hotelImg{width:100%;height: 207px; border-radius: 4px 0px 0px 4px;}
.hotelImgs .no-room-img{bottom:45px;height:35px;line-height:35px;}
.hotelImgs .text-font-hidden{position:absolute;bottom:12px;width:100%;font-size: 14px;color: #FFFFFF;background:rgba(70, 37, 36, 0.5);cursor:pointer;
      text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
/* .hotellike{width: 0px;height: 25px;float: left;}
.dolike{position: relative;left: -50px;width: 35px;height: 25px;top: 15px;cursor: pointer;} */
.hotelname{font-weight: 650;font-style: normal;font-size: 16px;color: #303133;}
.hotelmess{display: inline-block;width:67%;height: 207px;position: relative;border-radius: inherit;}
.hotelMessage{margin: 0px 10px;}
.hotelMessage div{margin-top: 5px;}
.hotelmess a{text-decoration:none;}
.sold0zh{background: url(https://res.roompai.com/static/img/frame/sold-ch.png) no-repeat;background-position: right bottom; background-color: #fff;background-size: 25%;}
.sold0en{background: url(https://res.roompai.com/static/img/frame/sold-en.png) no-repeat;background-position: right bottom; background-color: #fff;background-size: 25%;}
.hoteltags{font-weight: 400;font-style: normal;color: #FCD205;}
.hotellocation{font-weight: 400;font-style: normal;font-size: 14px;color: #303133;}
.hotelselect{width:120px;height: 115px;float: right;bottom: 0;right: 0; position:absolute;}
.remain{padding:3px 5px; min-width: 59px;min-height: 20px;background: inherit;background-color: rgba(246, 228, 231, 1);font-weight: 400;font-size: 12px;color: #DC143C;text-align: center;line-height: 20px;margin-left:5px;}
.remain-empty{min-height: 20px;min-width: 65px;}
.hotelmoney{font-weight: 650;font-size: 22px;color: #E12D2D;}
.currency-text{font-weight: 400;font-size: 10px; margin-right: 5px;}
.doselect{width: 100%;height: 40px;background-color: rgba(83, 146, 249, 1);border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;font-weight: 400;font-style: normal;font-size: 14px;color: #FFF;line-height: 40px;text-align: center;}
.hotelpages div{display: inline-block;}
.hotelpages{margin-top: 100px;margin-bottom: 20px;}
.hotel-totaltext{font-size: 14px;font-weight:400;color:#4F4C4C;width:30%;}
.hotel-totaltext span{font-weight:650;color:#5392F9;}
.pageinfo{width:68%;text-align:right;}
.hotelImgs .hotel-like-0{width:30px;height:30px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;position:absolute;top:15px;right:15px;cursor: pointer;fill: pink;}
.hotelImgs .hotel-like-1{width:30px;height:30px;background-position-x:center;background-size: 100%;background-repeat: no-repeat;position:absolute;top:15px;right:15px;cursor: pointer;fill:red;}
.no-hover{fill:red;}
.content-empty-text{font-size: 14px;color: #4F4C4C;text-align: center; margin-top: 10px;}
.content-empty-img{width:200px; height:200px;}

/* 手机版 排序 */
.sort-info div{height: 50px; line-height: 50px;font-size: 14px;text-align:center; border-top: 1px solid rgba(221, 223, 226, 1);}
@media screen and (min-width: 1401px) {
.location-search,.list-content {width:1100px;min-height: 700px;}
.location-search-mobile, .list-top{display: none;}
.hotelprice-empty{border-width: 0px;width: calc(100% - 12px);height: 50px;background-color: rgba(225, 45, 45, 0.09803921568627451);border-radius: 4px;font-size: 13px;position: absolute; bottom: 0;color: #E12D2D;line-height: 50px;padding-left: 12px;}
.hotelselect div{margin-top: 5px;float: right;margin-right: 10px;}
.hotelImgs .hotel-like-0:not(.no-hover):hover{fill: rgb(255, 120, 120);}
}
@media only screen and (min-width:1001px) and (max-width:1400px){
.location-search,.list-content {width:1100px;min-height: 700px;}
.location-search-mobile, .list-top{display: none;}
.hotelprice-empty{border-width: 0px;width: calc(100% - 12px);height: 50px;background-color: rgba(225, 45, 45, 0.09803921568627451);border-radius: 4px;font-size: 13px;position: absolute; bottom: 0;color: #E12D2D;line-height: 50px;padding-left: 12px;}
.hotelselect div{margin-top: 5px;float: right;margin-right: 10px;}
.hotelImgs .hotel-like-0:not(.no-hover):hover{fill: rgb(255, 120, 120);}
}
@media screen and (max-width: 1000px) {
.match-hotel{height: 40px; background: inherit; background-color: rgba(83, 146, 249, 0.9215686274509803); border: none; border-radius: 10px; border-bottom-right-radius: 0px; border-bottom-left-radius: 0px; -moz-box-shadow: none; -webkit-box-shadow: none; box-shadow: none;margin-bottom: 0px; margin-top:0px; font-weight: 500; font-style: normal; font-size: 16px; color: #FFFFFF; line-height: 40px; padding-left: 10px;}
.is-hidden{display: none;}
.remain-empty{min-height: 26px;min-width: 59px; float:left;}
.list-search{width: 100%; }
.hotelselect{height: 40px;}
  .location-search, .doselect, .tagAll{ display: none;}
  .location-search .hotellist-region,.el-date-editor--daterange.el-input__inner{width:100%;}
  .content, .hotellist{ margin-top: 0;}
  .hotellist{margin-bottom: 10px;box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%); border: none;height: 207px;margin-top: 0px;border-radius: 4px;}
  .list-content{width:95%;}
  .list-left{display: none;}
  .list-right{width:100%;}
  .hotel-like-0,.hotel-like-1{left:70%;}
  .hotelMessage{ height: 60%;}
  .hotel-totaltext{width:100%; margin-bottom:10px;}
  .hotelpages{margin-top: 10px;}
  .hotelprice-empty{border-width: 0px;width: calc(100% - 12px);height: 25px;background-color: rgba(225, 45, 45, 0.09803921568627451);border-radius: 4px;font-size: 12px;position: absolute; bottom: 0;color: #E12D2D;line-height: 25px;padding-left: 12px;}
  .el-icon-caret-bottom{text-align: center;}
  /* .el-button:focus, .el-button:hover,.el-select .el-input.is-focus .el-input__inner{color:rgba(83, 146, 249, 1);background-color:#fff;} */
  .hotelImg{object-fit: cover;}
  .hotelselect{width:100%;}
  .hotelselect div{margin-top: 5px;margin-right: 10px;}
  .remain{float:left; margin-left: 10px;}
  .hotelmoney{float:right;}
  .sold0zh{background: url(https://res.roompai.com/static/img/frame/sold-ch.png) no-repeat;background-position: right bottom; background-color: #fff;background-size: 40%;}
.sold0en{background: url(https://res.roompai.com/static/img/frame/sold-en.png) no-repeat;background-position: right bottom; background-color: #fff;background-size: 40%;}
.hotelImgs .hotel-like-0,.hotelImgs .hotel-like-1{top:5px;}
}
</style>
<style>
.el-drawer__open .el-drawer.btt{height:auto !important;}
</style>



// WEBPACK FOOTER //
// src/components/hotelsearch/TextHotelList.vue